<template>
  <div class="" v-if="categoryList.length > 0">
    <template v-for="cat in categoryList">
      <div class="pic-list" :class="cat.name" v-if="cat.list.length > 0" :key="cat.name">
        <swiper class="swiper" :ref="cat.name" :options="swiperOption">
          <swiper-slide v-for="item in cat.list" :key="item.pageProductId">
            <div class="item" :style="`background-image: url('${item.pageProductUrl}')`" @click="toDetail(item)">
              <div class="btn" :class="cat.theme">{{ item.pageProductName_translate }}</div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </template>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import ProductCategory from '@/mixins/ProductCategory'

export default {
  name: 'OtherSwiper',
  props: ['hotelId', 'listData'],
  mixins: [ProductCategory],
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  created() {},
  computed: {},
  methods: {
    toDetail(item) {
      // productType 1 商品 2 活动 3 服务
      this.$router.push(`/product/${item.pageProductId}?type=${item.productType}`)
    },
  },
}
</script>

<style scoped lang="sass"></style>
